import { AuthUser } from '../../../typings/auth.def'
import { createContext, useContext } from 'react'

export type AuthProviderContextProps = {
  authUser?: AuthUser | null
  setAuthUser: (user: AuthUser) => void
  unsetAuthUser: () => void
  userId?: number
}

// @ts-ignore
export const AuthProviderContext = createContext<AuthProviderContextProps>()

export const useAuthContext = () =>
  useContext<AuthProviderContextProps>(AuthProviderContext)
